<template>
    <transition name="modal-fade">
        <div class="modal" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t('selectionDelete') }}</h5>
                    <button type="button" class="btn-close" data-dismiss="modal" @click="close" aria-label="Close" />
                </div>
                <div class="modal-body">
                    <label v-if="this.$parent.selectionNotEmpty" class="form-label">{{ $t('selectionNotEmpty') }}</label>
                    <template v-else-if="this.$parent.foundSelections.length > 0">
                        <label class="form-label">{{ $t('cannotDeleteSelection') }}</label>
                        <div v-for="(selection, i) in this.$parent.foundSelections" :key="i">
                            <RouterLink :to="'/modeling/' + this.$route.params.id + '/modelingresult/' + selection.resultId ">
                                {{ selection.name }} - Id: {{selection.resultId}}
                            </RouterLink>
                        </div>
                    </template>
                    <p v-else>{{ $t('wannaDeleteThisSelection') }}</p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="close" data-dismiss="modal" >
                        {{ $t('close') }}
                    </button>
                    <button type="button" class="btn btn-primary" @click="deleteSelection" :disabled="this.$parent.foundSelections.length > 0 || this.$parent.selectionNotEmpty">
                        {{ $t('delete') }}
                    </button>
                </div>
                </div>
            </div>
        </div>      
    </transition>
</template>

<script>
import SelectionApi from "../../api/server/selection";

export default {
    name: "selectionDeleteModal",
    methods: {
        close() {
            this.$emit("closeDeleteDialog");
        },
        async deleteSelection() {
            await SelectionApi.selectionDelete(this.$parent.$route.params.id, this.$parent.$route.params.selectionId);
            this.$emit("closeDeleteDialog");
            this.$emit("reload");
        }
    }
}
</script>